// ABOUTME: Session planting limit helpers and screen-to-ground raycasting
// ABOUTME: The drag-and-drop palette flow lives in main.js

import * as THREE from 'three';

const SESSION_KEY = 'hopp.session.planted';

const raycaster = new THREE.Raycaster();
const ndc = new THREE.Vector2();
const groundPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
const planeFallback = new THREE.Vector3();

export function getSessionPlantCount() {
    try {
        const raw = localStorage.getItem(SESSION_KEY);
        if (!raw) return 0;
        const n = Number.parseInt(raw, 10);
        return Number.isFinite(n) && n > 0 ? n : 0;
    } catch {
        return 0;
    }
}

export function isSessionPlanted(limit = 1) {
    return getSessionPlantCount() >= limit;
}

export function markSessionPlanted() {
    try {
        const next = getSessionPlantCount() + 1;
        localStorage.setItem(SESSION_KEY, String(next));
    } catch {}
}

export function clearSessionPlanted() {
    try {
        localStorage.removeItem(SESSION_KEY);
    } catch {}
}

export function screenToWorld(clientX, clientY, camera, container, pickTarget) {
    const rect = container.getBoundingClientRect();
    ndc.x = ((clientX - rect.left) / rect.width) * 2 - 1;
    ndc.y = -((clientY - rect.top) / rect.height) * 2 + 1;
    raycaster.setFromCamera(ndc, camera);

    if (pickTarget) {
        const hits = raycaster.intersectObject(pickTarget, false);
        if (hits.length > 0) {
            const p = hits[0].point;
            return { x: p.x, y: p.y, z: p.z };
        }
    }

    const hit = raycaster.ray.intersectPlane(groundPlane, planeFallback);
    if (!hit) return null;
    return { x: planeFallback.x, y: 0, z: planeFallback.z };
}
